import {
	OrderSummary400ErrorHeader,
	OrderSummary400ErrorText,
	OrderSummary403ErrorHeader,
	OrderSummary403ErrorText,
	OrderSummaryDefaultErrorHeader,
	OrderSummaryDefaultErrorText
} from "constants/text";
import styles from "containers/Orders/order-styles.module.css";
import { useMemo } from "react";
import { APIErrorCustomBannerWrapper } from "./APIErrorCustomBanner.styles.ts";

interface APIErrorCustomBannerProps {
	statusCode: number;
}

const APIErrorCustomBanner = ({ statusCode }: APIErrorCustomBannerProps) => {
	const imageSrc =
		statusCode === 400 || statusCode === 403
			? "/assets/NoOrdersSadBoxImage.svg"
			: "/assets/UserAuthServiceError.svg";

	const getStatusText = (statusCode: number) => {
		if (statusCode === 400) {
			return { header: OrderSummary400ErrorHeader, subheader: OrderSummary400ErrorText };
		} else if (statusCode === 403) {
			return { header: OrderSummary403ErrorHeader, subheader: OrderSummary403ErrorText };
		} else {
			return { header: OrderSummaryDefaultErrorHeader, subheader: OrderSummaryDefaultErrorText };
		}
	};

	const { header, subheader } = useMemo(() => getStatusText(statusCode), [statusCode]);

	return (
		<APIErrorCustomBannerWrapper data-testid="api-failure">
			<img
				src={imageSrc}
				alt="API Error"
				className={styles.noOrdersErrorBannerContainerImage}
				data-testid="error-sad-box-img"
			/>
			<span
				className={styles.noOrderSummaryErrorBannerStatus}
				data-testid="error-status-code"
			>
				(Error Code: {statusCode})
			</span>
			<h5 data-testid="error-header">{header}</h5>
			<p data-testid="error-subheader">{subheader}</p>
		</APIErrorCustomBannerWrapper>
	);
};

export default APIErrorCustomBanner;
